import {Add} from '@mui/icons-material';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {i18n} from 'src/i18n';
import ModeloTareaAutocompleteFormItem from 'src/view/modeloTarea/autocomplete/ModeloTareaAutocompleteFormItem';
import Message from 'src/view/shared/message';

type QuickCreateChildDialogProps = {
  open: boolean;
  onClose: () => void;
  onCreate: (modeloTarea: any) => void;
  creating?: boolean;
};

function QuickCreateChildDialog({open, onClose, onCreate, creating}: QuickCreateChildDialogProps) {
  const form = useForm({defaultValues: {modeloTarea: null}});

  const submit = (values) => {
    if (!values.modeloTarea) {
      Message.error(i18n('entities.tarea.childTasksSelectModel'));
      return;
    }
    onCreate(values.modeloTarea);
  };

  return (
    <Dialog open={open} onClose={creating ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{i18n('entities.tarea.quickChildTaskTitle')}</DialogTitle>
      <DialogContent sx={{pt: 1}}>
        <FormProvider {...form}>
          <form>
            <ModeloTareaAutocompleteFormItem
              name="modeloTarea"
              label={i18n('entities.tarea.fields.modeloTarea')}
              required={true}
              showCreate={false}
              autoFocus={true}
              menuPortalTarget={document.body}
            />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={creating}>
          {i18n('common.cancel')}
        </Button>
        <Button
          onClick={form.handleSubmit(submit)}
          disabled={creating}
          variant="contained"
          startIcon={creating ? undefined : <Add />}>
          {creating ? <CircularProgress size={20} /> : i18n('entities.tarea.newChildTask')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default QuickCreateChildDialog;
